<template>
  <div
    class="button-group"
    :class="`is-aligned-${align}`"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'CButtonGroup',

  props: {
    align: {
      type: String,
      default: 'start',
      validator: value => [
        'start',
        'center',
        'end'
      ].includes(value)
    }
  }
}
</script>

<style lang="scss">
@import "../css/variables";

.button-group {
  display: flex;
  flex-wrap: wrap;
  gap: $gutter-xs;

  &.is-aligned-start {
    justify-content: flex-start;
  }

  &.is-aligned-center {
    justify-content: center;
  }

  &.is-aligned-end {
    justify-content: flex-end;
  }
}
</style>
